@if (showBanner()) {
<div
  class="network-status-banner"
  [class.network-status-banner--offline]="bannerSeverity() === 'offline'"
  [class.network-status-banner--unstable]="bannerSeverity() === 'unstable'"
  role="alert"
  aria-live="assertive"
>
  <tui-icon icon="@tui.badge-alert" class="network-status-banner__icon" />
  <span class="network-status-banner__message">{{ bannerMessage() }}</span>
  <button
    tuiButton
    type="button"
    size="s"
    appearance="whiteblock"
    class="network-status-banner__action"
    (click)="recheckConnection()"
  >
    Check connection
  </button>
</div>
}
